import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Logo } from '../components/Logo';
import { LegalFooter } from '../components/LegalFooter';
import { LEGAL, ACTUALIZADO } from '../lib/legal';

function Tabla({ cols, rows }) {
  return (
    <div className="legal-tabla-wrap">
      <table className="legal-tabla">
        <thead><tr>{cols.map((c) => <th key={c}>{c}</th>)}</tr></thead>
        <tbody>{rows.map((r, i) => <tr key={i}>{r.map((v, j) => <td key={j}>{v}</td>)}</tr>)}</tbody>
      </table>
    </div>
  );
}

export default function Legal({ tipo }) {
  const { t, i18n } = useTranslation();
  const doc = LEGAL[tipo];
  if (!doc) return null;

  return (
    <div className="landing legal-page" data-testid={`legal-${tipo}`}>
      <header className="landing-top">
        <Logo endoso />
        <Link className="btn ghost sm" to="/" data-testid="legal-inicio">{t('legal.volver')}</Link>
      </header>

      <article className="legal-doc">
        <h1 className="legal-titulo">{doc.titulo}</h1>
        <p className="muted small" data-testid="legal-actualizado">{t('legal.actualizado')}: {ACTUALIZADO}</p>
        {i18n.language === 'en' && (
          <div className="banner small" data-testid="legal-en-note">{t('legal.en_note')}</div>
        )}

        {doc.secciones.map((s, i) => (
          <section key={i} className="legal-seccion">
            <h2>{s.h}</h2>
            {(s.p || []).map((par, j) => <p key={j}>{par}</p>)}
            {s.tabla && <Tabla cols={s.tabla.cols} rows={s.tabla.rows} />}
          </section>
        ))}
      </article>

      <LegalFooter />
    </div>
  );
}
